import React from 'react';
import { useFormContext } from 'react-hook-form';
import LoadingButton from '@mui/lab/LoadingButton';
import Button from '@mui/material/Button';
import ControlledNumberInput from '@/components/common/form/ControlledNumberInput';
import ControlledTextField from '@/components/common/form/ControlledTextField';
import translate from '@/lib/intl/translate';

type ConfidenceLevelFormProps = {
  onCancel: () => void;
  isEditing?: boolean;
};

export default function ConfidenceLevelForm({
  onCancel,
  isEditing = false,
}: ConfidenceLevelFormProps) {
  const {
    control,
    formState: { errors, isSubmitting },
  } = useFormContext();

  return (
    <>
      <div className="grid grid-cols-2 gap-4">
        <ControlledTextField
          control={control}
          fullWidth
          name="name"
          label={translate('CONFIDENCE_LEVEL_NAME_LABEL')}
          disabled={!isEditing}
          error={!!errors?.name}
          rules={{
            required: translate('FORMS_VALIDATION_REQUIRED'),
          }}
          required
          helperText={
            (errors.name ? errors.name.message : '') as React.ReactNode
          }
        />
        <ControlledNumberInput
          control={control}
          decimalScale={0}
          name="amount"
          id="confidence-level-amount-field"
          label={translate('CONFIDENCE_LEVEL_PERCENTAGE_LABEL')}
          // @ts-expect-error type mismatch when inferring types from js component
          parse={parseInt}
          suffix="%"
          required
          disabled={!isEditing}
          error={!!errors?.name}
          rules={{
            required: translate('FORMS_VALIDATION_EMAIL_REQUIRED'),
            min: {
              value: 0,
              message: translate('CONFIDENCE_LEVEL_AMOUNT_MINIMUM_ERROR'),
            },
            max: {
              value: 100,
              message: translate('CONFIDENCE_LEVEL_AMOUNT_MAXIMUM_ERROR'),
            },
          }}
          helperText={errors.amount ? errors.amount.message : ''}
        />
      </div>
      {isEditing && (
        <div className="mt-4 flex flex-row-reverse">
          <LoadingButton
            type="submit"
            variant="contained"
            size="small"
            loading={isSubmitting}
          >
            {translate('SAVE')}
          </LoadingButton>
          <Button onClick={onCancel} size="small">
            {translate('CANCEL')}
          </Button>
        </div>
      )}
    </>
  );
}
